<template>
  <div class="nrbAboutTraining">
    <section class="section">
      <div class="container">
        <div class="container_1250">
          <div class="about_content about_training">
            <VueFaqAccordion
                :items="myItems"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'
//import UInput2 from "@/components/core/UInput2";

export default {
  name: "chaldalFaq",
  components: {
    //UInput2,
    VueFaqAccordion
  },
  data () {
    return {
      myItems: [
        {
          title: 'What is the duration of the course?\n',
          value: 'The Upskill x Chaldal is a 1.5 month-long program.\n',
          category: 'FAQ'
        },
        {
          title: 'What is the deadline for registration?\n',
          value: 'Registration closes on 25th February 2021 \n',
          category: 'FAQ'
        },
        {
          title: 'What are the prerequisites for the course? \n',
          value: 'Yes. Candidates are required to have knowledge of the fundamentals of CS \n',
          category: 'FAQ'
        },
        {
          title: 'How do I register for the course? \n',
          value: 'The registration form is available on this page\n',
          category: 'FAQ'
        },
        {
          title: 'Do I have to pay for the course? \n',
          value: 'You will only have to pay Upskill BDT 15,000 from your first month’s salary if you are hired by Chaldal. \n',
          category: 'FAQ'
        },
        {
          title: 'Does course completion guarantee job placement at Chaldal?\n',
          value: 'No. Only a selected number of participants of the course will receive job placement at Chaldal.',
          category: 'FAQ'
        },
        {
          title: 'What happens if I don’t get a job at Chaldal?\n',
          value: 'If you don’t get this job at Chaldal, you will still be added to Upskill’s select pool of talent, which both local and global startups will hire from. \n',
          category: 'FAQ'
        },
        {
          title: 'Do I receive the employee endorsed certificate regardless of placement at Chaldal?\n',
          value: 'Yes. Every participant of the CSS Course will receive an employee endorsed certificate jointly issued by Upskill and Chaldal. \n',
          category: 'FAQ'
        },
        {
          title: 'When are the classes scheduled?\n',
          value: 'You will be informed of the class schedule on the day of orientation of the course. \n',
          category: 'FAQ'
        },
        {
          title: 'How does an ISA work?\n',
          value: 'Simple. You take part in the course free of cost. You will only pay Upskill BDT 15,000 from your first month’s salary if you are hired by Chaldal. \n',
          category: 'FAQ'
        },
        {
          title: 'How much do I have to pay Upskill if I am hired by Chaldal? \n',
          value: 'You will be required to make a one-time payment of BDT 15,000 to Upskill from your first month’s salary only if you are hired by Chaldal. \n',
          category: 'FAQ'
        }
      ],
      clone: []
    }
  },
  methods: {
    search(e) {
      if (e == "") {
        this.myItems = this.clone
      } else {
        this.myItems = this.clone.filter(o => o.title.includes(e) || o.value.includes(e))
      }
    }
  },
  created() {
    this.clone = this.myItems
  }
}
</script>